module.exports = __webpack_public_path__ + "static/img/ikona_cw7-ON.dc61829c.png";